
export default {
  name: 'CartVehicleCompatibility',

  props: {
    vehicles: {
      type: Array,
      default: () => [],
    },
  },
}
